import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";    
import ForgetPwd from "../pages/Authentication/ForgotPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";     
import UserProfile from "../pages/Authentication/UserProfile";

// Admin pages
import Dashboard from "../pages/admin/dashboard/Dashboard";
import DrugList from "../pages/admin/drugs/DrugList";
import DrugAdd from "../pages/admin/drugs/DrugAdd";
import DrugEdit from "../pages/admin/drugs/DrugEdit";
import UserList from "../pages/admin/users/UserList";
import UserAdd from "../pages/admin/users/UserAdd";
import UserEdit from "../pages/admin/users/UserEdit";
import AssignedDrugsUser from "../pages/admin/users/AssigneDrugsUser";
import UserVerification from "../pages/admin/users/UserVerification";
import AssignDrugList from "../pages/admin/assigndrugs/AssignDrugList";
import AssignDrugListOption from "../pages/admin/assigndrugs/AssignDrugListOption";

// User pages
import UserDashboard from "../pages/user/UserDashboard";
import Patients from "../pages/user/Patients";
import Appointments from "../pages/user/Appointments";

// Shared pages
import { Notifications } from "../pages/shared";
  
const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: <Dashboard /> },
  { path: "/change-password", exact: true, component: <ChangePassword /> },
  { path: "/user-profile", exact: true, component: <UserProfile /> },
  { path: "/drug-list", exact: true, component: <DrugList /> },
  { path: "/user-verification", exact: true, component: <UserVerification /> },
  { path: "/drug-add", exact: true, component: <DrugAdd /> },
  { path: "/drug-edit/:id", exact: true, component: <DrugEdit /> },
  { path: "/user-list", exact: true, component: <UserList /> },
  { path: "/doctor-groups", exact: true, component: <Navigate to="/user-list?view=shared-login" replace /> },
  { path: "/user-add", exact: true, component: <UserAdd /> },
  { path: "/user-edit/:id", exact: true, component: <UserEdit /> },
  { path: "/assigne-drug/:id", exact: true, component: <AssignedDrugsUser /> },
  { path: "/notifications-list", exact: true, component: <Notifications /> },
  { path: "/user-list/:inactive", exact: true, component: <UserList /> },
  {
    path: "/dashboard",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const authProtectedRoutesUser = [
  { path: "/dashboard", exact: true, component: <UserDashboard /> },
  { path: "/change-password", exact: true, component: <ChangePassword /> },
  { path: "/user-profile", exact: true, component: <UserProfile /> },
  { path: "/patients", exact: true, component: <Patients /> },
  { path: "/appointments", exact: true, component: <Appointments /> },
  { path: "/assgined-user-drug-list", exact: true, component: <AssignDrugList /> },
  { path: "/assgined-user-drug-form/:id", exact: true, component: <AssignDrugListOption /> },
  { path: "/notifications-list", exact: true, component: <Notifications /> },
   
  {
    path: "/dashboard",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes, authProtectedRoutesUser };
